import React, {useEffect, useRef} from 'react';

import {Button, Card, CardContent, CardMedia, Stack, Typography} from '@mui/material';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import {basePath} from './PseudoDatabase'
import {useParams} from "react-router-dom";
import {MainComponentPaper} from "./StyledControls";
import {useBreakpoint} from "./useBreakpoint";
import PropTypes from "prop-types";
import {usePicture} from "./UsePicture";
import SwipeablePictureViewer from "./SwipeablePictureViewer";


export default function Home() {

    let { id } = useParams();

  //  const [pictures,_setPictures] = useState([]);
    const staticImage =
    {id: 10, title: 'Twelve Apostles' , description: 'The Twelve Apostles', path: "TwelveApostles.jpg", orientation: 'landscape'};
    const pics = usePicture();
    const pictures = useRef(null)

    useEffect(() => {
        pictures.current  = pics.getPictures();
    }, [pics]);




    if (!pictures.current || pictures.current.length===0) {
        return (
            <>

                    <MainComponentPaper>
                        {/*<DelayedSpinner/>*/}
                        <SimpleMediaCard
                            currentImage={staticImage}
                            noNav
                        />
                    </MainComponentPaper>

            </>
        )
    } else {
        return (
            <ImageViewer id={id} pictures={pictures.current}/>
        )
    }
}

export function ImageViewer({pictures,id}) {
    return (
        <MainComponentPaper>
            <SwipeablePictureViewer pictures={pictures} id={id}/>

        </MainComponentPaper>
    )
}

/**
 * xs, extra-small: 0px
 * sm, small: 600px
 * md, medium: 900px
 * lg, large: 1200px
 * xl, extra-large: 1536px
 * @type {Map<any, any>}
 */


export const breakpoints = new Map();
breakpoints.set('xs', {width: '412', });
breakpoints.set('sm', {width: '600', });
breakpoints.set('md', {width: '900', });
breakpoints.set('lg',{width: '1200', });
breakpoints.set('xl', {width: '1500',});

export function  Width  ()  {
    const breakPoint = useBreakpoint();
    return breakpoints.get(breakPoint).width;
}

export function SimpleMediaCard({currentImage,right,left, noNav=false}) {

    const breakPoint = useBreakpoint();


    if (!currentImage) {return null}
    const url = currentImage.orientation==='landscape' ? basePath + 'tr:w-' + Width() + '/'  +  currentImage.path : basePath + 'tr:h-' + Width() + '/'  +  currentImage.path
    console.log('breakPoint',breakPoint,Width());
    if (breakPoint==='xl' || breakPoint==='lg' ) {
        return (

            <LargeViewer currentImage={currentImage} right={right} left={left} noNav={noNav} width={Width()} url={url}  />
        );
    } else {
        return (

            <PhoneViewer currentImage={currentImage} right={right}    url={url}/>
        );
    }
}

SimpleMediaCard.defaultProps = {
    noNav: false,
}

SimpleMediaCard.propTypes = {
    currentImage: PropTypes.object.isRequired,
    left: PropTypes.func,
    right: PropTypes.func,
    noNav: PropTypes.bool
};

function LargeViewer({currentImage,right,left, noNav,  url}) {
    console.log('noNav',noNav);
    return (
        <div>
            <Stack direction="row" spacing={2}>
                {noNav===false && (
                    <Button
                        size="small"
                        onClick={left}
                        aria-label={'Previous image'}
                    >
                        <KeyboardArrowLeftIcon />
                    </Button>
                )}
                <Card

                >
                    {currentImage.orientation==='landscape' && (
                        <CardMedia

                            sx={(theme) => ({
                                paddingTop: '56.25%',
                                [theme.breakpoints.down('sm')]: { paddingTop: '70.25%'},
                                height: 0,

                                width: Width()+'px',
                                objectFit: "contain",
                                backgroundSize: 'contain'
                            })}
                            image={url}
                            title={currentImage.title}
                        />
                    )}
                    {currentImage.orientation==='portrait' && (
                        <CardMedia
                            sx={(theme) => ({
                                paddingTop: '56.25%',
                                [theme.breakpoints.down('sm')]: {
                                    paddingTop: '100%',
                                    marginLeft: '5%',
                                    marginRight: '5%',
                                },
                                height: 0,
                                width: Width()+'px',
                                objectFit: "contain",
                                backgroundSize: 'contain'
                            })}

                            image={url}
                            title={currentImage.title}
                        />
                    )}

                    <CardContent>
                        <Typography gutterBottom variant="h" component="div">
                            {currentImage.title}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            {currentImage.description}
                        </Typography>
                    </CardContent>

                </Card>
                {noNav===false && (
                    <Button
                        size="small"
                        onClick={right}
                        aria-label={'Next image'}
                    >
                        <KeyboardArrowRightIcon />
                    </Button>
                )}
            </Stack>

        </div>
    )
}

function PhoneViewer({currentImage,right, url}) {
    return (


                <Card
                    onClick={right}

                >
                    {currentImage.orientation==='landscape' && (
                        <CardMedia

                            sx={(theme) => ({
                                paddingTop: '56.25%',
                                [theme.breakpoints.down('sm')]: { paddingTop: '70.25%'},
                                height: 0,

                                width: '100%',
                                objectFit: "contain",
                                backgroundSize: 'contain'
                            })}
                            image={url}
                            title={currentImage.title}
                        />
                    )}
                    {currentImage.orientation==='portrait' && (
                        <CardMedia
                            sx={(theme) => ({
                                paddingTop: '56.25%',
                                [theme.breakpoints.down('sm')]: {
                                    paddingTop: '100%',

                                },
                                height: 0,
                                width: '100%',
                                objectFit: "contain",
                                backgroundSize: 'contain'
                            })}

                            image={url}
                            title={currentImage.title}
                        />
                    )}

                    <CardContent>
                        <Typography gutterBottom variant="h6" component="div">
                            {currentImage.title}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            {currentImage.description}
                        </Typography>
                    </CardContent>

                </Card>

    )
}



